

export default class ConfigScript {
    constructor() {
        this.timestamp = new Date().getTime()
        
    }

    loadScript(url, callback) {
        const scriptTag = document.createElement("script");
        scriptTag.setAttribute("async","");
        scriptTag.setAttribute("src",url);
        scriptTag.onload = callback;
        document.head.appendChild(scriptTag);
    }
    useFirebase() {
        return new Promise((resolve) => {
            this.loadScript("https://www.gstatic.com/firebasejs/8.10.1/firebase-app.js", () => {
                if (!window.isLockdown.isLockdownEnabled()) {
                    this.loadScript("https://www.gstatic.com/firebasejs/8.10.1/firebase-analytics.js", () => {
                        this.loadScript(`/js/init-firebase.js`, () => {
                            resolve(true)
                        })
                    })
                } else {
                    this.loadScript(`/js/init-firebase.js`, () => {
                        resolve(true)
                    })
                }
            })
        })
    }
    

}
